// Template definitions for different layout styles
export const templateDefinitions = {
    classic: {
        id: 'classic',
        name: 'Classic',
        description: 'Original working layout - traditional header with centered survey below',
        backgroundColor: '#fff',
        backgroundImage: null,
        backgroundType: 'solid',
        textColor: '#222',
        borderStyle: 'solid',
        borderColor: '#eee',
        borderWidth: 1,
        surveyPosition: 'center',
        surveyMaxWidth: 'none',
        surveyBackground: 'transparent',
        surveyBorder: 'none',
        headerOverlay: false,
        customCSS: `
            .template-layout {
                background-color: #000000 !important;
            }
            .template-content {
                padding-top: 0 !important;
                height: calc(100vh - 200px) !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                justify-content: flex-start !important;
            }
            .survey-container {
                width: 100% !important;
                max-width: none !important;
                padding: 0 !important;
                background: transparent !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                flex-grow: 1 !important;
                justify-content: flex-start !important;
                overflow: auto !important;
            }
            .review-form {
                width: 100% !important;
                background-color: #000000 !important;
                padding-bottom: 2vh !important;
            }
            .rating-container {
                flex-grow: 1 !important;
                width: 100% !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                justify-content: flex-start !important;
                overflow: auto !important;
            }
            .text-content p {
                font-size: 2rem !important;
                text-align: center !important;
                color: white !important;
                line-height: 1.4 !important;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
                margin-bottom: 2vh !important;
            }
            .rating-icons {
                display: flex !important;
                justify-content: space-around !important;
                width: 70% !important;
                margin-bottom: 3vh !important;
            }
            .submit-button {
                background: linear-gradient(180deg, #272B30 0%, #1A1D21 100%) !important;
                color: white !important;
                border: 2px solid #272B30 !important;
                padding: 1.2em 2.7em !important;
                border-radius: 12px !important;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25) !important;
                cursor: pointer !important;
                display: block !important;
                margin: auto !important;
                font-size: 1.1rem !important;
                font-weight: 600 !important;
                margin-bottom: 3vh !important;
                margin-top: 3vh !important;
                transition: all 0.3s ease !important;
                letter-spacing: 0.03em !important;
            }
            .submit-button:hover:not(.disabled) {
                transform: translateY(-2px) !important;
                box-shadow: 0 6px 10px rgba(0, 0, 0, 0.3) !important;
                background: linear-gradient(180deg, #32373e 0%, #22262b 100%) !important;
            }
            .submit-button.disabled {
                background: #2a2e34 !important;
                color: #a1a1a1 !important;
                box-shadow: none !important;
                cursor: not-allowed !important;
            }
            @media (max-width: 768px) {
                .text-content p {
                    font-size: 1.5rem !important;
                }
                .submit-button {
                    padding: 1em 2.2em !important;
                    font-size: 1rem !important;
                }
            }
            @media (max-width: 480px) {
                .text-content p {
                    font-size: 1.3rem !important;
                }
                .submit-button {
                    padding: 0.9em 2em !important;
                }
            }
        `,
        preview: '/assets/templates/classic-preview.jpg'
    },
    
    overlay: {
        id: 'overlay',
        name: 'Overlay Style',
        description: 'Survey overlays the header for immersive experience',
        backgroundColor: '#000000',
        backgroundImage: null,
        backgroundType: 'solid',
        textColor: '#ffffff',
        borderStyle: 'glass',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        surveyPosition: 'overlay',
        surveyMaxWidth: '500px',
        surveyBackground: 'rgba(0, 0, 0, 0.7)',
        surveyBorder: 'glass',
        headerOverlay: true,
        customCSS: `
            .survey-overlay {
                backdrop-filter: blur(10px);
                border-radius: 20px;
                box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
            }
        `,
        preview: '/assets/templates/overlay-preview.jpg'
    },
    
    modern: {
        id: 'modern',
        name: 'Modern',
        description: 'Clean card-based design with subtle shadows',
        backgroundColor: '#f7f7f7',
        backgroundImage: null,
        backgroundType: 'solid',
        textColor: '#333',
        borderStyle: 'rounded',
        borderColor: '#ccc',
        borderWidth: 2,
        surveyPosition: 'center',
        surveyMaxWidth: '480px',
        surveyBackground: '#ffffff',
        surveyBorder: 'rounded',
        headerOverlay: false,
        customCSS: `
            .survey-card {
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                border-radius: 12px;
                padding: 2rem;
            }
            .header-image {
                border-radius: 12px;
            }
        `,
        preview: '/assets/templates/modern-preview.jpg'
    },
    
    gradient: {
        id: 'gradient',
        name: 'Gradient Background',
        description: 'Beautiful gradient background with glass effect',
        backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        backgroundImage: null,
        backgroundType: 'gradient',
        textColor: '#ffffff',
        borderStyle: 'glass',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
        surveyPosition: 'center',
        surveyMaxWidth: '550px',
        surveyBackground: 'rgba(255, 255, 255, 0.1)',
        surveyBorder: 'glass',
        headerOverlay: false,
        customCSS: `
            .glass-effect {
                backdrop-filter: blur(15px);
                border-radius: 16px;
                border: 1px solid rgba(255, 255, 255, 0.2);
            }
        `,
        preview: '/assets/templates/gradient-preview.jpg'
    },
    
    minimal: {
        id: 'minimal',
        name: 'Minimal Clean',
        description: 'Ultra-clean minimal design with lots of whitespace',
        backgroundColor: '#ffffff',
        backgroundImage: null,
        backgroundType: 'solid',
        textColor: '#2c3e50',
        borderStyle: 'none',
        borderColor: '#ecf0f1',
        borderWidth: 0,
        surveyPosition: 'center',
        surveyMaxWidth: '400px',
        surveyBackground: 'transparent',
        surveyBorder: 'none',
        headerOverlay: false,
        customCSS: `
            .minimal-survey {
                margin-top: 3rem;
                padding: 1.5rem;
            }
            .minimal-text {
                font-weight: 300;
                line-height: 1.6;
            }
        `,
        preview: '/assets/templates/minimal-preview.jpg'
    },
    
    vibrant: {
        id: 'vibrant',
        name: 'Vibrant Colors',
        description: 'Bold, colorful design with high contrast',
        backgroundColor: '#FF6B6B',
        backgroundImage: null,
        backgroundType: 'solid',
        textColor: '#ffffff',
        borderStyle: 'solid',
        borderColor: '#ffffff',
        borderWidth: 3,
        surveyPosition: 'center',
        surveyMaxWidth: '520px',
        surveyBackground: 'rgba(255, 255, 255, 0.9)',
        surveyBorder: 'rounded',
        headerOverlay: false,
        customCSS: `
            .vibrant-survey {
                border-radius: 20px;
                box-shadow: 0 6px 20px rgba(255, 107, 107, 0.3);
            }
            .vibrant-text {
                color: #2c3e50;
                font-weight: 600;
            }
        `,
        preview: '/assets/templates/vibrant-preview.jpg'
    }
};

// Helper function to get template by ID
export const getTemplate = (id) => {
    return templateDefinitions[id] || templateDefinitions.classic;
};

// Helper function to get all template IDs
export const getTemplateIds = () => {
    return Object.keys(templateDefinitions);
};

// Helper function to get all templates as array
export const getAllTemplates = () => {
    return Object.values(templateDefinitions);
};
